document.addEventListener("DOMContentLoaded", () => {
  const form = document.querySelector("form.searchwp-form"); // Adjust selector if needed

  if (form) {
    form.addEventListener("keydown", (e) => {
      // Prevent form submission when Enter is pressed inside an input
      if (e.key === "Enter" && e.target.tagName === "INPUT") {
        e.preventDefault();
      }
    });
  }
});
